import classNames from "classnames";

export interface HelpTextProps {
  id: string;
  helpText: React.ReactNode;
  className?: React.HTMLAttributes<HTMLElement>["className"];
}

export const HelpText = (props: HelpTextProps) => {
  return (
    <span
      id={props.id}
      className={classNames("nsw-form__helper", props.className)}
    >
      {props.helpText}
    </span>
  );
};
